import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Dismiss from '../../__partials/dismiss';
import Subhead from '../../type/subhead';
import Text from '../../type/text';
import Button from '../../buttons/button';
import Indicator from '../__partials/indicator';

import './style.scss';

const Notice = ({ type, style, title, message, action, collapseMargin, qaId, onDismiss }) => {
  let noticeRef = null;
  const isMinimalStyle = style === 'minimal';

  const noticeClasses = classNames('uni-notice', 'uni-env--light', {
    'uni-notice--minimal': isMinimalStyle,
    [`uni-util__collapse-margin--${collapseMargin}`]: collapseMargin,
  });

  const handleDismiss = () => {
    if (noticeRef !== null) {
      noticeRef.classList.add('uni-notice--dismissing');
    }

    onDismiss();
  };

  const handleActionClick = () => {
    action.handler();
    handleDismiss();
  };

  let noticeAction;
  if (action) {
    const noticeButtonSize = style === 'standard' ? 'small' : 'xsmall';
    if (action.href) {
      noticeAction = (
        <a
          className={`uni-btn--subtle uni-btn--${noticeButtonSize}`}
          href={action.href}
          target={action.target}
          data-qa-id={action.qaId}
        >
          {action.text}
        </a>
      );
    } else {
      noticeAction = (
        <Button
          size={noticeButtonSize}
          type="subtle"
          text={action.text}
          qaId={action.qaId}
          onClick={handleActionClick}
        />
      );
    }
  }

  return (
    <div
      className={noticeClasses}
      data-qa-id={qaId}
      ref={notice => {
        noticeRef = notice;
      }}
    >
      <Indicator
        size={isMinimalStyle ? 'medium' : 'large'}
        type={type === 'success' ? 'confirmation' : type}
        paddingSpace={isMinimalStyle ? 'half' : 'one'}
      />
      <div className="uni-notice__content">
        <Dismiss
          size={isMinimalStyle ? 'small' : 'medium'}
          className="uni-notice__dismiss"
          qaId="notice-dismiss-action"
          onClick={handleDismiss}
        />
        {isMinimalStyle && (
          <Text level="small" isTight>
            {title && (
              <Subhead level="small" className="uni-margin--quarter--right">
                {title}
              </Subhead>
            )}
            {message}
          </Text>
        )}
        {!isMinimalStyle && (
          <div>
            {title && <Subhead level="default">{title}</Subhead>}
            <Text isTight>{message}</Text>
          </div>
        )}
        {noticeAction}
      </div>
    </div>
  );
};

Notice.propTypes = {
  type: PropTypes.oneOf(['information', 'warning', 'critical', 'confirmation', 'success']).isRequired,
  style: PropTypes.oneOf(['standard', 'minimal']).isRequired,
  title: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  action: PropTypes.shape({
    text: PropTypes.string,
    handler: PropTypes.func,
    href: PropTypes.string,
    target: PropTypes.oneOf(['_self', '_blank', '_parent', '_top']),
    qaId: PropTypes.string,
  }),
  collapseMargin: PropTypes.oneOf(['top', 'bottom', 'vertical']),
  qaId: PropTypes.string,
  onDismiss: PropTypes.func.isRequired,
};

Notice.defaultProps = {
  type: 'information',
  style: 'standard',
  onDismiss: () => {},
};

export default Notice;



// WEBPACK FOOTER //
// ./src/notifications/notice/index.jsx